import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios'
import getters from './store/modules/getters'
import actions from './store/modules/actions'
import state from './store/modules/state'
import mutations from './store/modules/mutations'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
     //strict: true,
     state,
     getters,
     mutations,
     actions
})
